import TYPES from '@/types';
import { currencyFormat } from '@/vue-app/utils/currency';

// Domain
import {
  GoalEarningsSegment,
} from '@/modules/flagship/investor-goal/goal-tracking/domain/dtos/goal-earnings-segment-dto';
import {
  GoalTrackingEntity,
} from '@/modules/flagship/investor-goal/goal-tracking/domain/entities/goal-tracking-entity';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class CustomProgressBarViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  readonly i18n_namespace = 'components.goals-dashboard.details-goals.custom-progress-bar';

  display_tooltip = false;

  segments: Array<GoalEarningsSegment> = []

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  getSource = (is_a_bucket_goal: boolean) => (
    is_a_bucket_goal ? this.translate('tooltip_budget') : this
      .translate('tooltip_2')
  );

  addSegment = (percent: number, amount: number, class_name: string, show_tooltip: boolean) => {
    this.segments.push({
      percent,
      amount: `${currencyFormat(amount)} MXN`,
      class_name,
      show_tooltip,
    });
  }

  setBudgetGoalSegments = (goal_tracking: GoalTrackingEntity) => {
    if (goal_tracking.contributions_percent >= 1) {
      this.addSegment(goal_tracking.contributions_percent, goal_tracking.contributions, 'accent first', false);
    }

    if (goal_tracking.earnings_percent >= 1) {
      this.addSegment(goal_tracking.earnings_percent, goal_tracking.earnings, 'sky-blue last', true);
    } else if (this.segments.length > 0) {
      this.segments[0].class_name += ' last';
    }
  }

  setNotBudgetGoalSegments = (goal_tracking: GoalTrackingEntity) => {
    if (goal_tracking.contributions_percent >= 1) {
      this.addSegment(goal_tracking.contributions_percent, goal_tracking.contributions,
        'accent first', false);
    }

    if (goal_tracking.earnings_percent >= 1) {
      this.addSegment(goal_tracking.earnings_percent, goal_tracking.earnings, 'sky-blue',
        true);
    }

    if (goal_tracking.remaining_percent >= 1) {
      let class_name = 'inactive accent last';
      if (this.segments.length === 0) {
        class_name += ' first';
      }
      this.addSegment(goal_tracking.remaining_percent, goal_tracking.remaining_balance, class_name,
        false);
    } else if (this.segments.length > 2) {
      this.segments[1].class_name += ' last';
    }
  }

  setSegments = (goal_tracking: GoalTrackingEntity, is_a_bucket_goal: boolean) => {
    this.segments.length = 0;
    if (goal_tracking) {
      if (is_a_bucket_goal) {
        this.setBudgetGoalSegments(goal_tracking);
      } else {
        this.setNotBudgetGoalSegments(goal_tracking);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  displayHelpTooltip = ({ mouseenter, mouseleave }, event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    mouseenter(event);
    this.display_tooltip = !this.display_tooltip;
    if (this.display_tooltip) {
      mouseenter(event);
    }
    if (!this.display_tooltip) {
      mouseleave(event);
    }
  }
}
